import { Component, OnInit, EventEmitter, Output, Inject, Renderer2, ViewChild, ElementRef, DOCUMENT } from '@angular/core';

import { Subject, takeUntil } from 'rxjs';

import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';

// models
import { CartModel } from './topbar.model';
import { cartData } from './data';
import { User } from 'src/app/core/user/user.types';
import { NotificationModel } from 'src/app/core/notifications/models/notification.model';

// services

import { LanguageService } from '../../core/services/language.service';
import { NotificationService } from 'src/app/core/notifications/service/notification.service';

// state
import { NotificationsState } from 'src/app/core/notifications/state/notifications.state';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

//component
import { AIChatPoupUpComponent } from 'src/app/pages/deben-AI-assistant/ai-chat-poup-up/ai-chat-poup-up.component';
import { ChatBotState } from 'src/app/pages/deben-AI-assistant/state/chatBot.state';

@Component({
    selector: 'app-topbar',
    templateUrl: './topbar.component.html',
    styleUrls: ['./topbar.component.scss'],
    standalone: false
})
export class TopbarComponent implements OnInit {
  element: any;
  mode: string | undefined;
  @Output() mobileMenuButtonClicked = new EventEmitter();
  cartData!: CartModel[];
  total = 0;
  cart_length: any = 0;
  userData!: User;
  userAvatar: any;
  flagvalue: any;
  valueset: any;
  countryName: any;
  cookieValue: any;
  isNewNotification: boolean = false;
  notificationsList: NotificationModel[];
  isLoading: boolean = false;
  runningEventText: string = '';
  private _unsubscribeAll: Subject<any> = new Subject<any>();

  chatBotModalRef: any
  isModalOpen = false;
  isFullScreen = false;
  isModalVisible = false;




  @ViewChild('scrollRef') scrollRef: any;
  @ViewChild(AIChatPoupUpComponent) aiChatComponent!: AIChatPoupUpComponent; // Reference to the child component

  chatMessages: any[] = [];



  constructor(@Inject(DOCUMENT) private document: any, public languageService: LanguageService, private _modalService: NgbModal,
    public _cookiesService: CookieService, public _translate: TranslateService,
    public _notificationService: NotificationService) { }

  ngOnInit(): void {

    ChatBotState.getChatMessagesState().subscribe((messages) => {
      this.chatMessages = messages;
    });


    this.element = document.documentElement;

    //  Fetch Data
    this.cartData = cartData;
    this.cart_length = this.cartData.length;
    this.cartData.forEach((item) => {
      var item_price = item.quantity * item.price
      this.total += item_price
    });


    // this._notificationService.onMessage("/queue/events").subscribe((notification) => {
    //   console.log(notification)
    // });

    // Subscribe to the user State
    // UserState.getUserState()
    //   .pipe(takeUntil(this._unsubscribeAll))
    //   .subscribe((user: User) => {
    //     this.userData = user;
    //   })

    // // Get User Photo State    
    // UserState.getUserPhotoState()
    //   .pipe(takeUntil(this._unsubscribeAll))
    //   .subscribe((userAvatar: SafeUrl) => {
    //     this.userAvatar = userAvatar;
    //   })

    // // NotificationsState.getNotificationsState()
    // // .pipe(takeUntil(this._unsubscribeAll))
    // // .subscribe((data : PageableResponse<NotificationModel[]>) => {

    // // })

    // Get Socket Notification State    
    NotificationsState.getSocketEventState()
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe((data: any) => {
        if (data) {
          //console.log(data);
          this.runningEventText = data.eventDescription;
          setTimeout(() => {
            this.runningEventText = ''
          }, 30000);
          // if (data.event === "AUTO_CATEGORIZATION_FINISHED" || data.event === "OB_CONSENT_UPDATED") {
          // }
        }
      })

  }

  /**
 *dismissAlert method
 */

  dismissAlert() {
    this.runningEventText = '';
  }




  /**
   * getChatBotMaxHeight
   * Determines the maximum height for the chatbot based on the screen size 
   * and whether it is in full-screen mode.
   */

  getChatBotHeight(): string {
    if (this.isFullScreen) {
      return '100%';
    } else {
      const width = window.innerWidth;

      if (width <= 1366) {
        return '700px';
      } else if (width >= 1367 && width < 2560) {
        return '1000px';
      } else {
        return '1100px';
      }
    }
  }


  /**
 * openChatBotModal
 */
  openChatBotModal() {
    this.isModalVisible = true;
    this.chatMessages = this.aiChatComponent.chatMessages!
    // Check if chatMessages has data
    if (!this.chatMessages || this.chatMessages.length === 0) {
      // If there's no data, call startConversion in the child component
      this.aiChatComponent.startConversion();
    }

    // this.aiChatComponent.onListScroll()
  }


  /**
   * toggleChatbotFullScreen
   * Toggles the chatbot between full-screen and normal mode.
   */
  toggleChatbotFullScreen() {
    // Toggle the full-screen state
    this.isFullScreen = !this.isFullScreen;

    // Select the modal, prompt, whiteSpace, accordion-flush, and parent elements from the DOM
    const modal = document.querySelector('.modal-container') as HTMLElement;
    const chatConversation = document.querySelector('.chat-conversation ') as HTMLElement;
    const prompt = document.querySelector('.prompt') as HTMLElement;
    const width = window.innerWidth; // Get the current window width

    if (modal) { // Check if the modal element exists
      if (this.isFullScreen) { // If entering full-screen mode
        modal.classList.add('fullscreen');

        if (width >= 1024 && width < 1920) {
          chatConversation.style.height = 'calc(100vh - 225px)';
        } else if (width >= 1920 && width < 2560) {
          prompt.style.marginBottom = '360px';
          chatConversation.style.height = 'calc(100vh - 231px)';
        } else if (width >= 2560) {
          prompt.style.marginBottom = '560px';
          chatConversation.style.height = 'calc(100vh - 231px)';
        }
      } else { // If exiting full-screen mode
        modal.classList.remove('fullscreen');
        chatConversation.style.height = '';
        prompt.style.height = '';
        prompt.style.marginBottom = '';
      }
    }


    // this.aiChatComponent.onListScroll()
  }





  /**
   * closechatBotModal
   */

  closechatBotModal() {

    const modal = document.querySelector('.modal-container') as HTMLElement;
    const chatConversation = document.querySelector('.chat-conversation ') as HTMLElement;
    const prompt = document.querySelector('.prompt') as HTMLElement;

    modal.classList.remove('fullscreen');
    chatConversation.style.height = '';
    prompt.style.height = '';
    prompt.style.marginBottom = '';


    this.isModalOpen = false
    this.isFullScreen = false
    this.isModalVisible = false;

  }


  /**
   * Toggle the menu bar when having mobile screen
   */
  toggleMobileMenu(event: any) {
    event.preventDefault();
    this.mobileMenuButtonClicked.emit();
  }




  /**
   * Fullscreen method
   */
  fullscreen() {
    document.body.classList.toggle('fullscreen-enable');
    if (
      !document.fullscreenElement && !this.element?.mozFullScreenElement &&
      !this.element?.webkitFullscreenElement) {
      if (this.element?.requestFullscreen) {
        this.element?.requestFullscreen();
      } else if (this.element?.mozRequestFullScreen) {
        /* Firefox */
        this.element?.mozRequestFullScreen();
      } else if (this.element?.webkitRequestFullscreen) {
        /* Chrome, Safari and Opera */
        this.element?.webkitRequestFullscreen();
      } else if (this.element?.msRequestFullscreen) {
        /* IE/Edge */
        this.element?.msRequestFullscreen();
      }
    } else {
      if (this.document.exitFullscreen) {
        this.document.exitFullscreen();
      } else if (this.document.mozCancelFullScreen) {
        /* Firefox */
        this.document.mozCancelFullScreen();
      } else if (this.document.webkitExitFullscreen) {
        /* Chrome, Safari and Opera */
        this.document.webkitExitFullscreen();
      } else if (this.document.msExitFullscreen) {
        /* IE/Edge */
        this.document.msExitFullscreen();
      }
    }
  }

  //disable dark mode for now
  /**
  * Topbar Light-Dark Mode Change
  */
  // changeMode(mode: string) {
  //   this.mode = mode;
  //   this.eventService.broadcast('changeMode', mode);

  //   switch (mode) {
  //     case 'light':
  //       document.body.setAttribute('data-layout-mode', "light");
  //       document.body.setAttribute('data-sidebar', "light");
  //       break;
  //     case 'dark':
  //       document.body.setAttribute('data-layout-mode', "dark");
  //       document.body.setAttribute('data-sidebar', "dark");
  //       break;
  //     default:
  //       document.body.setAttribute('data-layout-mode', "light");
  //       break;
  //   }
  // }



  // checkForDirectionChange(dir: string): void {
  // this.renderer.removeClass(document.body, 'ltr');
  // this.renderer.removeClass(document.body, 'rtl');
  // this.renderer.addClass(document.body, dir);
  // this.renderer.setAttribute(document.documentElement, 'dir', this._cookiesService.get('dir'));
  // }

  /**
   * Logout the user
   */
  // logout() {
  //   this._authService.signOut();
  //   this.router.navigate(['/auth']);
  // }

  windowScroll() {
    if (document.body.scrollTop > 100 || document.documentElement.scrollTop > 100) {
      document.getElementById('back-to-top')?.classList.remove('d-none');
    } else {
      document.getElementById('back-to-top')?.classList.add('d-none');
    }
  }

  // Delete Item
  /**
 * Delete Item Function
 * @param event
 * @param id
 */

  deleteItem(event: any, id: any) {
    var price = event.target.closest('.dropdown-item').querySelector('.item_price').innerHTML;
    var Total_price = this.total - price;
    this.total = Total_price;
    this.cart_length = this.cart_length - 1;
    this.total > 1 ? (document.getElementById("empty-cart") as HTMLElement).style.display = "none" : (document.getElementById("empty-cart") as HTMLElement).style.display = "block";
    document.getElementById('item_' + id)?.remove();
  }

  // Search Topbar Function
  Search() {
    var searchOptions = document.getElementById("search-close-options") as HTMLAreaElement;
    var dropdown = document.getElementById("search-dropdown") as HTMLAreaElement;
    var input: any, filter: any, ul: any, li: any, a: any | undefined, i: any, txtValue: any;
    input = document.getElementById("search-options") as HTMLAreaElement;
    filter = input.value.toUpperCase();
    var inputLength = filter.length;

    if (inputLength > 0) {
      dropdown.classList.add("show");
      searchOptions.classList.remove("d-none");
      var inputVal = input.value.toUpperCase();
      var notifyItem = document.getElementsByClassName("notify-item");

      Array.from(notifyItem).forEach(function (element: any) {
        var notifiTxt = ''
        if (element.querySelector("h6")) {
          var spantext = element.getElementsByTagName("span")[0].innerText.toLowerCase()
          var name = element.querySelector("h6").innerText.toLowerCase()
          if (name.includes(inputVal)) {
            notifiTxt = name
          } else {
            notifiTxt = spantext
          }
        } else if (element.getElementsByTagName("span")) {
          notifiTxt = element.getElementsByTagName("span")[0].innerText.toLowerCase()
        }
        if (notifiTxt)
          element.style.display = notifiTxt.includes(inputVal) ? "block" : "none";

      });
    } else {
      dropdown.classList.remove("show");
      searchOptions.classList.add("d-none");
    }
  }

  /**
   * Search Close Btn Function
   */
  closeBtn() {
    var searchOptions = document.getElementById("search-close-options") as HTMLAreaElement;
    var dropdown = document.getElementById("search-dropdown") as HTMLAreaElement;
    var searchInputReponsive = document.getElementById("search-options") as HTMLInputElement;
    dropdown.classList.remove("show");
    searchOptions.classList.add("d-none");
    searchInputReponsive.value = "";
  }

  /**
   * Open New Notification Function
   */
  openNewNotification() {
    this.isNewNotification = false;
    this.isLoading = true;
    this._notificationService.getAllNotifications(0, 5).subscribe((data) => {
      this.notificationsList = data?.content
      this.isLoading = false;
    })
  }

  /**
    * On destroy
    */

  ngOnDestroy(): void {
    // Unsubscribe from all subscriptions
    this._unsubscribeAll.next(null);
    this._unsubscribeAll.complete();

    this.isModalOpen = false;
    this.isFullScreen = false;
  }

}
